module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-container weex-ct weex-div",
    style: ({
      'width': _vm._px2rem(_vm.width + 'px', 75),
      'height': _vm._px2rem(_vm.height + 'px', 75)
    }),
    attrs: {
      "weex-type": "div",
      "data-evt-click": "",
      "data-evt-swipe": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "swipe": function($event) {
        $event.stopPropagation();
        return _vm.onSwipe($event)
      },
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onchange($event)
      }
    }
  }, [_c('div', {
    staticClass: "switch-bar weex-ct weex-div",
    style: ({
      'width': _vm._px2rem(_vm.width + 'px', 75),
      'height': _vm._px2rem(_vm.height + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['container', _vm.isChecked ? 'selected' : 'unselected'],
    style: ({
      'width': _vm._px2rem(_vm.width - 4 + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }), _vm._v(" "), _c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: ("contain"),
      expression: "\"contain\""
    }],
    ref: "switchBar",
    staticClass: "switch-icon weex-el weex-image",
    style: ({
      'width': _vm._px2rem(_vm.height + 'px', 75),
      'height': _vm._px2rem(_vm.height + 'px', 75),
      'left': _vm._px2rem(_vm.width - _vm.height + 2 + 'px', 75)
    }),
    attrs: {
      "src": _vm.icon,
      "resize": "contain",
      "data-img-src": _vm.icon,
      "weex-type": "image"
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a9725816", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9725816","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-switch-bar/index.vue
// module id = 662
// module chunks = 0 1